import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DriverWorkflow } from '@symfa-inc/providence-verizon-types';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import {
  DriverManagementHttpService,
  LeasingHttpService,
} from '@core/services/http';
import { useLeasingTabPrefetch } from '@core/utils/hooks';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { Financial } from '@shared/components/financial';
import { LeasingActions } from '@store/actions';
import { LeasingSelectors } from '@store/selectors';

export const LeasingFinancial: FC = () => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();

  const isLoading = useSelector(
    LeasingSelectors.getTabLoadingState('financial'),
  );
  const isDataLoaded = useSelector(
    LeasingSelectors.getTabLoadedState('financial'),
  );

  useLeasingTabPrefetch('financial', projectBundleID);

  const fetchData = async () => {
    if (!isDataLoaded) {
      dispatch(
        LeasingActions.setTabLoading.done({
          tabName: 'financial',
          isLoading: true,
        }),
      );

      await HttpService.getHttpRequests(
        LeasingHttpService,
      ).getPermittingFinancialData(projectBundleID);

      await HttpService.getHttpRequests(
        DriverManagementHttpService,
      ).getDriversListByWorkflow(DriverWorkflow.Permitting);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, isDataLoaded]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-permitting-financial loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Financial
      feeAccessPath="permitting"
      siteDataRootPath={['leasing', 'tabData', 'summary', 'site']}
      projectTypeSelector={LeasingSelectors.getProjectType}
      projectIdSelector={LeasingSelectors.getProjectId}
    />
  );
};
